import axios from 'axios';

const instance = axios.create({
  baseURL: "https://cs248vz1i3.execute-api.us-east-2.amazonaws.com/v1"
});

export default instance;